import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  style: {"display":"none","margin-left":"9999px"}
}

import { ref, reactive, computed, watch } from 'vue';
import Taro, { showLoading, showToast } from '@tarojs/taro';
import universalCell from '@/components/universal-cell/index.vue';
import videoUploader from '@/components/VideoUploader/index.vue';
import upload from '@/components/upload/index.vue';
import videoPlayer from '@/pages/index/components/select-media-list/videoPlayer.vue';
import { electronicDeleteFile } from '@/service/uploading';

interface Props {
  labelWidth?: string;
  mt?: string;
  mode?: 'upload' | 'view'; // 新增模式参数：upload-上传模式，view-查看详情模式
  label?: string;
  imageOnly?: boolean; // 新增：仅图片上传模式
  maxCount?: number; // 新增：最大上传数量
}

export default /*@__PURE__*/_defineComponent({
  __name: 'attachment',
  props: /*@__PURE__*/_mergeModels({
    labelWidth: { default: () => '80px' },
    mt: { default: () => '0px' },
    mode: { default: () => 'upload' },
    label: { default: () => '附件' },
    imageOnly: { type: Boolean, default: () => false },
    maxCount: { default: () => 9 }
  }, {
    "files": {
  default: () => [],
},
    "filesModifiers": {},
    "rawAttachments": {
  default: () => [],
},
    "rawAttachmentsModifiers": {},
  }),
  emits: ["update:files", "update:rawAttachments"],
  setup(__props: any, { expose: __expose }) {

let videoUploaderRef = ref<InstanceType<typeof videoUploader> | null>(null);
let videoPlayerRef = ref<InstanceType<typeof videoPlayer> | null>(null);
let uploadRef = ref<
  | (InstanceType<typeof upload> & {
      uploaderRef?: { chooseImage: () => void };
    })
  | null
>(null);

const props = __props;

let initNo = ref<number>(0);
let showPreview = ref<boolean>(false);
// 内部格式化后的文件数组
let uploadFiles = _useModel<
  { _type: string; accessUrl: string; fileType: string; url: string }[]
>(__props, 'files');

// 接收原始附件数据用于格式化
const rawAttachments = _useModel<any[]>(__props, 'rawAttachments');
let mediaTypeVisible = ref<boolean>(false);
let themeVars = reactive({
  'actionsheet-item-font-size': '18px',
  'font-size-base': '18px',
});

// 根据imageOnly属性动态生成菜单选项
const menuMedia = computed(() => {
  if (props.imageOnly) {
    return [
      { id: '2', name: '照片' },
      { id: '3', name: '取消' },
    ];
  }
  return [
    { id: '1', name: '视频' },
    { id: '2', name: '照片' },
    { id: '3', name: '取消' },
  ];
});

// 选择媒体上传类型
const mediaChoose = (item: { id: string; name: string }) => {
  console.log('选择媒体上传类型', item);
  if (item.id === '1') {
    videoUploaderRef.value?.handleClick();
  }
  if (item.id === '2') {
    console.log('uploadRef.value', uploadRef.value?.uploaderRef?.chooseImage());
  }
};

// 视频上传成功
const videoSuccess = data => {
  // 确保 uploadFiles.value 是数组
  if (!Array.isArray(uploadFiles.value)) {
    uploadFiles.value = [];
  }
  
  // 检查是否超出最大上传数量
  if (uploadFiles.value.length >= props.maxCount) {
    showToast({ title: `最多只能上传${props.maxCount}个文件`, icon: 'none' });
    return;
  }
  uploadFiles.value.push({ ...data[0], _type: 'video' });
};
// 播放视频
const openvideoPlayer = (
  item: { url: string; accessUrl?: string; blobUrl?: string },
  index: string | number
) => {
  const videoItem = {
    url: item.accessUrl || item.url,
    blobUrl: item.blobUrl || '',
  };
  console.log('videoItem', videoItem);
  videoPlayerRef.value?.open(videoItem, index);
};
// 图片上传成功
const imageSuccess = data => {
  console.log('图片上传成功', data);
  
  // 确保 uploadFiles.value 是数组
  if (!Array.isArray(uploadFiles.value)) {
    uploadFiles.value = [];
  }
  
  // 修复：支持多张图片上传，遍历所有上传的图片
  if (Array.isArray(data)) {
    const remainingSlots = props.maxCount - uploadFiles.value.length;
    if (remainingSlots <= 0) {
      showToast({ title: `最多只能上传${props.maxCount}个文件`, icon: 'none' });
      return;
    }
    
    // 只添加剩余可用数量的文件
    const filesToAdd = data.slice(0, remainingSlots);
    filesToAdd.forEach(item => {
      uploadFiles.value.push({ ...item, _type: 'image' });
    });
    
    // 如果有文件被截断，提示用户
    if (data.length > remainingSlots) {
      showToast({ title: `已达到最大上传数量${props.maxCount}，部分文件未上传`, icon: 'none' });
    }
  } else {
    // 兼容单张图片的情况
    if (uploadFiles.value.length >= props.maxCount) {
      showToast({ title: `最多只能上传${props.maxCount}个文件`, icon: 'none' });
      return;
    }
    uploadFiles.value.push({ ...data, _type: 'image' });
  }
};
// 删除媒体
const deleteMedia = async (item, index: number) => {
  // 确保 uploadFiles.value 是数组
  if (!Array.isArray(uploadFiles.value)) {
    uploadFiles.value = [];
    return;
  }
  
  if (item?.eleId) {
    showLoading({ title: '删除中...' });
    await electronicDeleteFile(item.eleId);
  }
  uploadFiles.value.splice(index, 1);
  showToast({ title: '删除成功' });
};
// 打开图片预览
const openImagePreview = (item: any, originalIndex: number) => {
  // 计算当前图片在纯图片数组中的索引（排除视频）
  const imageOnlyArray = uploadFiles.value.filter(file => getAttachmentTypeIsImages(file));
  const imageIndex = imageOnlyArray.findIndex(img => 
    (img.accessUrl || img.url) === (item.accessUrl || item.url)
  );
  
  showPreview.value = true;
  initNo.value = imageIndex >= 0 ? imageIndex : 0;
};

// 图片预览
const showPreviewData = computed(() => {
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'svg',
    'ico',
    'tiff',
    'psd',
  ];

  // 添加数组类型检查，防止 map 方法调用失败
  if (!Array.isArray(uploadFiles.value)) {
    return [];
  }
  
  let result = uploadFiles.value.map(item => {
    if (
      (item?._type as string) == 'image' ||
      imageExtensions.includes((item.fileType as string)?.toLowerCase())
    ) {
      return { src: item.accessUrl || item.url };
    }
    return undefined;
  });
  return result.filter((item): item is { src: string } => item !== undefined);
});

// 视频
const getAttachmentTypeIsVideo = (row: {
  _type: string;
  fileType: string;
}): boolean => {
  const videoExtensions = [
    'mp4',
    'webm',
    'ogg',
    'mov',
    'mkv',
    'avi',
    'flv',
    'wmv',
    'mpg',
    'mpeg',
    '3gp',
  ];
  return (
    row._type === 'video' ||
    videoExtensions.includes(row.fileType?.toLowerCase())
  );
};

// 图片
const getAttachmentTypeIsImages = (row: {
  _type: string;
  fileType: string;
}): boolean => {
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'svg',
    'ico',
    'tiff',
    'psd',
  ];
  return (
    row._type === 'image' ||
    imageExtensions.includes(row.fileType?.toLowerCase())
  );
};

// 文件类型匹配方法，供外部使用
const getFileTypeByExtension = (
  fileName: string
): { _type: string; fileType: string } => {
  const fileExtension = fileName.split('.').pop()?.toLowerCase();

  const videoExtensions = [
    'mp4',
    'webm',
    'ogg',
    'mov',
    'mkv',
    'avi',
    'flv',
    'wmv',
    'mpg',
    'mpeg',
    '3gp',
  ];

  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'svg',
    'ico',
    'tiff',
    'psd',
  ];

  const isVideo = videoExtensions.includes(fileExtension || '');
  const isImage = imageExtensions.includes(fileExtension || '');

  return {
    _type: isVideo ? 'video' : isImage ? 'image' : 'image', // 默认为image
    fileType: fileExtension || 'jpg',
  };
};

// 监听原始附件数据变化，自动格式化
watch(
  rawAttachments,
  newRawAttachments => {
    // 确保 uploadFiles.value 始终是数组
    if (!Array.isArray(uploadFiles.value)) {
      uploadFiles.value = [];
    }
    
    if (
      newRawAttachments &&
      Array.isArray(newRawAttachments) &&
      newRawAttachments.length > 0
    ) {
      // 格式化原始附件数据
      uploadFiles.value = newRawAttachments.map((item: any) => {
        const fileName = item.fileName || item.name || '';
        const { _type, fileType } = getFileTypeByExtension(fileName);

        return {
          taroFilePath: item.filePath || '',
          filePath: item.filePath || '',
          url: item.url || '',
          uid: item.eleId || item.uid || '',
          name: item.fileName || item.name || '',
          _type,
          accessUrl: item.url || item.accessUrl || '',
          fileType,
          eleId: item.eleId || '',
          echo: true,
          status: 'success',
        };
      });
    }
  },
  { immediate: true, deep: true }
);

// 暴露方法供外部使用
__expose({
  uploadRef,
  getFileTypeByExtension,
});

return (_ctx: any,_cache: any) => {
  const _component_taro_image = _resolveComponent("taro-image")!
  const _component_nut_action_sheet = _resolveComponent("nut-action-sheet")!
  const _component_nut_config_provider = _resolveComponent("nut-config-provider")!
  const _component_nut_image_preview = _resolveComponent("nut-image-preview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(universalCell, {
        label: _ctx.label,
        labelWidth: _ctx.labelWidth,
        borderType: "none",
        class: "remark",
        mt: _ctx.mt,
        padding: "0"
      }, {
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (props.mode === 'upload' && _unref(uploadFiles).length < props.maxCount)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "w-150 h-150 bg-[#f7f8fa] flex-x-y-center rounded-[20px] m-r-10 m-t-10 m-l-0",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_isRef(mediaTypeVisible) //@ts-ignore
 ? mediaTypeVisible.value = true : mediaTypeVisible = true), ["stop"]))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "iconfont LY-tianjia text-size-80" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadFiles), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "relative w-150 h-150 m-[10px]"
              }, [
                (props.mode === 'upload')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => (deleteMedia(item, index)), ["stop"]),
                      class: "z-9 absolute right-[-20px] top-[-20px] LY-shanchu iconfont text-size-30 color-[#e92312]"
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (getAttachmentTypeIsVideo(item))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "w-full h-full bg-[#f7f8fa] flex-x-y-center bg-[rgba(0,0,0,.5)] overflow-hidden rounded-[20px]",
                      onClick: _withModifiers(($event: any) => (openvideoPlayer(item, index)), ["stop"])
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "LY-bofang iconfont text-size-80 color-[#fff]" }, null, -1)
                    ]), 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (getAttachmentTypeIsImages(item))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      onClick: _withModifiers(($event: any) => (openImagePreview(item, index)), ["stop"]),
                      class: "w-full h-full bg-[rgba(0,0,0,.5)] rounded-[20px]"
                    }, [
                      _createVNode(_component_taro_image, {
                        src: item.accessUrl || item.url,
                        mode: "aspectFit",
                        class: "w-full h-full flex-x-y-center"
                      }, null, 8, ["src"])
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["label", "labelWidth", "mt"]),
      (props.mode === 'upload')
        ? (_openBlock(), _createBlock(_component_nut_config_provider, {
            key: 0,
            "theme-vars": _unref(themeVars)
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_component_nut_action_sheet, {
                  title: "选择上传类型",
                  visible: _unref(mediaTypeVisible),
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(mediaTypeVisible) ? (mediaTypeVisible).value = $event : mediaTypeVisible = $event)),
                  "menu-items": menuMedia.value,
                  onChoose: mediaChoose
                }, null, 8, ["visible", "menu-items"])
              ]))
            ]),
            _: 1
          }, 8, ["theme-vars"]))
        : _createCommentVNode("", true),
      (props.mode === 'upload')
        ? (_openBlock(), _createBlock(videoUploader, {
            key: 1,
            ref_key: "videoUploaderRef",
            ref: videoUploaderRef,
            onSuccess: videoSuccess
          }, null, 512))
        : _createCommentVNode("", true),
      _createVNode(videoPlayer, {
        ref_key: "videoPlayerRef",
        ref: videoPlayerRef
      }, null, 512),
      (props.mode === 'upload')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              onSuccess: imageSuccess
            }, null, 512)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_nut_image_preview, {
        show: _unref(showPreview),
        "init-no": _unref(initNo),
        images: showPreviewData.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showPreview) //@ts-ignore
 ? showPreview.value = false : showPreview = false))
      }, null, 8, ["show", "init-no", "images"])
    ]))
  ], 64))
}
}

})